export enum NutriScoreCategory {
	StandardFood = 'StandardFood',
	Cheese = 'Cheese',
	Beverage = 'Beverage',
	AddedFat = 'AddedFat',
	Water = 'Water',
}
